import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiEndpoints } from '@common/constants';
import { ApiProvider } from '@providers/common/api.service';
import { UserProvider } from '@providers/user/user.service';


/*
  Generated class for the ShipProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
  providedIn: 'root'
})
export class ShipProvider {
  _usuarioProv = inject(UserProvider);
  private api = inject(ApiProvider);


  getList(byVIN = '') {
    const records = {
        VIN: byVIN.length === 17 ? byVIN : null
    };

    return new Promise((resolve, reject) => {
      const endpoint = apiEndpoints.getShipList;
      this.api.post(endpoint, records).subscribe({
        next: (data: any) => {
          if (data.ErrorMessage) {
            reject(data.ErrorMessage);
          } else {
            resolve(data.Ships);
          }
        },
        error: (error: HttpErrorResponse) => {
          reject(error.status + " " + error.statusText);
        },
      })
    });
  }

  /* getDetail(tripId: number) {
    const records = {
      Trips: [{
        IdViaje: tripId
      }]
    };
    return new Promise((resolve, reject) => {
      const endpoint = apiEndpoints.getTrackingDetail;
      this.api.post(endpoint, records, apiURL).subscribe(
        (data: any) => {
          if (data.ErrorMessage) {
            reject(data.ErrorMessage);
          } else {
            resolve(data.Trips);
          }
        },
        (error: HttpErrorResponse) => {
          reject(error.status + " " + error.statusText);
        }
      )
    });
  } */


}
